export default "__VITE_ASSET__Omcjf8l0__"